import { NgModule } from '@angular/core';
import { AccountBalanceModalComponent } from './account-balance-modal.component';
import { CommonModule } from '@angular/common';
import { CondomanagerService } from '../../../services/condomanager.service';
import { FormsModule } from '@angular/forms';
import { FieldsModule } from '../../fields/fields.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FieldsModule
    ],
    declarations: [
        AccountBalanceModalComponent
    ],
    exports: [
        AccountBalanceModalComponent
    ],
    providers: [
        CondomanagerService
    ],
})
export class AccountBalanceModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/account-balance-modal/account-balance-modal.module.ts